import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { EstimationUnitType } from '@atlassian/jira-insights-common/src/common/types.tsx';
import { getEstimatedUnit } from '@atlassian/jira-insights-common/src/common/utils/utils.tsx';
import type { Sprint, SprintCommitmentReportSuccess, SprintData } from '../../common/types.tsx';
import type { ArisReportData } from '../types.tsx';

export const transformSprintData =
	(estimationUnit: EstimationUnitType) =>
	(sprintData: SprintData): Sprint => {
		const completed = sprintData.completed
			? getEstimatedUnit(estimationUnit, sprintData.completed)
			: 0;
		const estimated = getEstimatedUnit(estimationUnit, sprintData.committed);

		return {
			id: Number(sprintData.sprint.id),
			estimated,
			completed,
			name: sprintData.sprint.name,
		};
	};

export const transformArisData = (data: ArisReportData): SprintCommitmentReportSuccess => {
	const { sprintHistory, sprintProgress, currentSprintId } = data;
	const { estimationUnit } = data.configuration;

	let currentSprintEstimated = 0;
	let total = 0;
	let sprints: Array<Sprint> = [];

	if (sprintProgress) {
		const {
			progress: { todo, inProgress, done },
		} = sprintProgress;
		currentSprintEstimated = todo.value + inProgress.value + done.value;
	}

	// average
	if (sprintHistory != null) {
		if (expValEquals('jira_insights_backlog_recommendations', 'cohort', 'control')) {
			sprints = sprintHistory.values.reverse().map((sprintData: SprintData) => {
				const completed = sprintData.completed
					? getEstimatedUnit(estimationUnit, sprintData.completed)
					: 0;
				const estimated = getEstimatedUnit(estimationUnit, sprintData.committed);
				total += completed;
				return {
					id: Number(sprintData.sprint.id),
					estimated,
					completed,
					name: sprintData.sprint.name,
				};
			});
		} else {
			sprints = sprintHistory.values.reverse().map(transformSprintData(estimationUnit));
			total = sprints.reduce((acc, sprint) => acc + sprint.completed, 0);
		}
	}

	const average = sprints.length > 0 ? total / sprints.length : 0;

	return {
		average,
		currentSprint: { estimated: currentSprintEstimated, id: currentSprintId },
		estimationUnit,
		sprints,
		type: 'SUCCESS',
	};
};
